import { lazy } from "react";

// project imports
import Loadable from "../component/Loadable/Index";
import MinimalLayout from "../layout/MinimalLayout/index";
const Login = Loadable(lazy(() => import("../container/Login/Index")));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
  
  path: "/",
  element: <MinimalLayout />,
  children: [
    {
      path: "/",
      element: <Login />,
    }
  ],
};

export default AuthenticationRoutes;
